<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/MaintainReport/RepairSum'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-4"> 
                <div class="form-group ">
                  <label class="label">ปี:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reYearStart'"
                    :name="'reYearStart'"
                    :select2-options="reYearOptions"
                    v-model="reYearStart"
                    ref="reYearStart"
                  ></select2>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right" v-if="this.$root.canShow(['OFFICER_QIMAINTAIN','OFFICER_PLANT_QIMAINTAIN','LEAD_QIMAINTAIN'])">
                <button
                  class="btn btn-outline-primary"
                  @click="exportExcel"
                  type="button"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
           <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table class="table-sm table-striped table-bordered table-hover table-checkable" id="reportTable" >
                <thead>
                  <tr>
                    <td rowspan="3" class="text-center font-weight-bold align-middle" style="background-color: #fce4d6;">ปี {{ reYearStart }}</td>
                    <td colspan="8" class="text-center font-weight-bold bgPlant">ซ่อมที่คลังอุปกรณ์เบียร์สดปากเกร็ด</td>
                    <td colspan="7" class="text-center font-weight-bold bgAgent">ซ่อมในตัวแทนจำหน่าย</td>
                  </tr>
                  <tr>
                    <td colspan="2" class="text-center font-weight-bold bgPlant">ซ่อมเครื่อง</td>
                    <td colspan="2" class="text-center font-weight-bold bgPlant">อะไหล่ซ่อมเครื่อง</td>
                    <td colspan="2" class="text-center font-weight-bold bgPlant">ซ่อมอุปกรณ์</td>
                    <td colspan="2" class="text-center font-weight-bold bgPlant">อะไหล่ซ่อมอุปกรณ์</td>
                    <td colspan="3" class="text-center font-weight-bold bgAgent">ซ่อมเครื่อง</td>
                    <td colspan="2" class="text-center font-weight-bold bgAgent">ซ่อมอุปกรณ์</td>
                    <td colspan="2" class="text-center font-weight-bold bgAgent">อะไหล่ซ่อมเครื่องและอุปกรณ์</td>
                  </tr>
                  <tr>
                    <!-- ซ่อมที่คลังอุปกรณ์เบียร์สดปากเกร็ด -->
                    <td class="text-center font-weight-bold bgPlant">จำนวนเครื่องรวม</td>
                    <td class="text-center font-weight-bold bgPlant">มูลค่า(ค่าบริการ)</td>
                    <td class="text-center font-weight-bold bgPlant">จำนวนอะไหล่/ชิ้น</td>
                    <td class="text-center font-weight-bold bgPlant">มูลค่า</td>
                    <td class="text-center font-weight-bold bgPlant">จำนวนอุปกรณ์/ชิ้น</td>
                    <td class="text-center font-weight-bold bgPlant">มูลค่า(ค่าบริการ)</td>
                    <td class="text-center font-weight-bold bgPlant">จำนวนอะไหล่/ชิ้น</td>
                    <td class="text-center font-weight-bold bgPlant">มูลค่า</td>
                    <!-- ซ่อมในตัวแทนจำหน่าย -->
                    <td class="text-center font-weight-bold bgAgent">จำนวนตัวแทน<br>(ซ่อมเครื่องและอุปกรณ์)</td>
                    <td class="text-center font-weight-bold bgAgent">จำนวนเครื่อง</td>
                    <td class="text-center font-weight-bold bgAgent">มูลค่า(ค่าบริการ)</td>
                    <td class="text-center font-weight-bold bgAgent">จำนวนอุปกรณ์/ชิ้น</td>
                    <td class="text-center font-weight-bold bgAgent">มูลค่า(ค่าบริการ)</td>
                    <td class="text-center font-weight-bold bgAgent">จำนวนอะไหล่/ชิ้น</td>
                    <td class="text-center font-weight-bold bgAgent">มูลค่า</td>
                  </tr>
                </thead>
                <tfoot>
                  <tr style="background-color: #fce4d6;">
                    <th>รวม</th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                  <tr>
                    <th colspan="15" class="text-right">รวมมูลค่าค่าบริการ</th>
                    <th class="text-right" id="totalService"></th>
                  </tr>
                  <tr>
                    <th colspan="15" class="text-right">รวมมูลค่าอะไหล่ที่ใช้</th>
                    <th class="text-right" id="totalParts"></th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;
    return {
      reYearStart: new Date().getFullYear(),
      reYearOptions: {
        placeholder: "กรุณาเลือก",
        data: [
          {
            id: new Date().getFullYear(),
            text: new Date().getFullYear(),
            data: null,
          },
          {
            id: new Date().getFullYear() - 1,
            text: new Date().getFullYear() - 1,
            data: null,
          },
          {
            id: new Date().getFullYear() - 2,
            text: new Date().getFullYear() - 2,
            data: null,
          },
        ],
      },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      this.reYearStart = new Date().getFullYear();
      $(`#reYearStart`).val(this.reYearStart).trigger("change");
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#reportTable").DataTable();
      table.search();
      table.draw();
    },
    exportExcel: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/QIJobs/ExportRepairSum",
        responseType: "arraybuffer",
        data: {
          YearStart: self.reYearStart
        },
      })
      .then(function(response) {
        if (response.status == "200") {
          let filename = "";
          let contentType = response.headers["content-type"];
          let disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          let blob = new Blob([response.data], { type: contentType });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire(
            "ไม่พบข้อมูล",
            "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา",
            "warning"
          );
        }
      })
      .catch(function(error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      })
      .then(function() {
        KTApp.unblockPage();
      });
    },
  },
  async mounted() {
    let self = this;

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.jobsDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.jobsDateStart).on("changeDate", function(e) {
      self.jobsDateStart = e.dates.length != 0 ? moment(e.date) : null;
    });

    $(self.$refs.jobsDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.jobsDateEnd).on("changeDate", function(e) {
      self.jobsDateEnd = e.dates.length != 0 ? moment(e.date) : null;
    });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#reportTable");
    const monthNames = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    table
      .DataTable({
        responsive: false,
        scrollX: true,
        scrollCollapse: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/QIJobs/SearchRepairSum",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            let jsonSearch = {
              YearStart: self.reYearStart
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
          dataSrc: function (json) {
            const dataFromApi = json.data || [];
            const fullMonthData = monthNames.map((monthName, index) => {
              const monthIndex = index + 1;
              const monthData = dataFromApi.find((d) => d.month === monthIndex) || {};
              return {
                month: monthName,
                totalRepairPlantMac: monthData.totalRepairPlantMac || 0,
                totalServiceCostPlantMac: monthData.totalServiceCostPlantMac || 0,
                totalItemsPlantMac: monthData.totalItemsPlantMac || 0,
                totalItemsCostPlantMac: monthData.totalItemsCostPlantMac || 0,
                totalRepairPlantEqpt: monthData.totalRepairPlantEqpt || 0,
                totalServiceCostPlantEqpt: monthData.totalServiceCostPlantEqpt || 0,
                totalItemsPlantEqpt: monthData.totalItemsPlantEqpt || 0,
                totalItemsCostPlantEqpt: monthData.totalItemsCostPlantEqpt || 0,
                totalRepairAgentCount: monthData.totalRepairAgentCount || 0,
                totalRepairAgentMac: monthData.totalRepairAgentMac || 0,
                totalServiceCostAgentMac: monthData.totalServiceCostAgentMac || 0,
                totalRepairAgentEqpt: monthData.totalRepairAgentEqpt || 0,
                totalServiceCostAgentEqpt: monthData.totalServiceCostAgentEqpt || 0,
                totalItemsAgent: monthData.totalItemsAgent || 0,
                totalItemsCostAgent: monthData.totalItemsCostAgent || 0,
              };
            });
            return fullMonthData;
          },
        },
        info: false,
        paging: false,
        searching: false,
        ordering: false,
        columns: [
          { data: "month", className: "text-center", render: $.fn.dataTable.render.number(',', '.', 0, '') },
          { data: "totalRepairPlantMac", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') },
          { data: "totalServiceCostPlantMac", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') },
          { data: "totalItemsPlantMac", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') },
          { data: "totalItemsCostPlantMac", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') },
          { data: "totalRepairPlantEqpt", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') },
          { data: "totalServiceCostPlantEqpt", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') },
          { data: "totalItemsPlantEqpt", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') },
          { data: "totalItemsCostPlantEqpt", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') },
          { data: "totalRepairAgentCount", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') },
          { data: "totalRepairAgentMac", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') },
          { data: "totalServiceCostAgentMac", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') },
          { data: "totalRepairAgentEqpt", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') },
          { data: "totalServiceCostAgentEqpt", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') },
          { data: "totalItemsAgent", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') },
          { data: "totalItemsCostAgent", className: "text-right", render: $.fn.dataTable.render.number(',', '.', 0, '') },
        ],
        footerCallback: function (row, data, start, end, display) {
          var api = this.api();

          const intVal = function (i) {
            return typeof i === "string" ? i.replace(/[\$,]/g, "") * 1 : typeof i === "number" ? i : 0;
          };

          api.columns([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], { page: "current" }).every(function () {
            var sum = this.data().reduce(function (a, b) {
              return intVal(a) + intVal(b);
            }, 0);
            $(this.footer()).html($.fn.dataTable.render.number(',', '.', 0, '').display(sum));
          });

          var totalService = 
            api.column(2).data().reduce((a, b) => intVal(a) + intVal(b), 0) +
            api.column(6).data().reduce((a, b) => intVal(a) + intVal(b), 0) +
            api.column(11).data().reduce((a, b) => intVal(a) + intVal(b), 0) +
            api.column(13).data().reduce((a, b) => intVal(a) + intVal(b), 0);

          var totalParts = 
            api.column(4).data().reduce((a, b) => intVal(a) + intVal(b), 0) +
            api.column(8).data().reduce((a, b) => intVal(a) + intVal(b), 0) +
            api.column(15).data().reduce((a, b) => intVal(a) + intVal(b), 0);

          $('#totalService').html($.fn.dataTable.render.number(',', '.', 0, '').display(totalService));
          $('#totalParts').html($.fn.dataTable.render.number(',', '.', 0, '').display(totalParts));
        },
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
  },
};
</script>

<style lang="scss" scoped>
.table-responsive {
  overflow-x: auto;
}
.bgPlant {
  background-color: #FFD966;
}
.bgAgent {
  background-color: #DAE9F8;
}
</style>


// WEBPACK FOOTER //
// App/Components/QIJob/ReportRepairSum.vue